import { useT } from "@/content/landing";
import { Reveal } from "./Reveal";
export function MoreChecks() {
  const t = useT();
  return <section className="bg-white py-20 sm:py-24">
      <div className="mx-auto max-w-6xl px-4 sm:px-6">
        <Reveal>
          <h2 className="text-2xl font-bold text-[#0F172A] sm:text-3xl">{t.moreChecks.title}</h2>
        </Reveal>
        <ul className="mt-10 grid gap-5 md:grid-cols-2">
          {t.moreChecks.items.map((item, i) => <Reveal as="li" key={item.title} delay={i * 60}>
              <div className="h-full rounded-2xl border border-black/5 bg-[#FAFBFC] p-6">
                <h3 className="text-base font-semibold text-[#0F172A]">{item.title}</h3>
                <p className="mt-2 text-sm leading-relaxed text-[#94A3B8]">{item.body}</p>
              </div>
            </Reveal>)}
        </ul>
      </div>
    </section>;
}